export const confidenceLabels = [
  'LOW', 'MID-LOW', 'MEDIUM', 'MID-HIGH', 'HIGH'
];

export const getConfidenceByLevel = (confidence) => confidence >= 0 ? confidenceLabels[confidence] : 'N/A';
